<template lang="html">
  <el-row class="bg-eee pd-tb10 border-radio10">
    <el-col :span="22" :offset="1">
      <el-row class="pd-tb10">
        <HdEditor
          v-model="questionData.content"
        />
        <!-- <el-input  placeholder="试题描述" v-model="questionData.content"></el-input> -->
      </el-row>
      <el-row class="pd-tb10 center" :key="index" v-for="(i,index) in questionData.options">
        <el-col :span="1" class="center">
          <el-radio v-model="questionData.answer" :label="index">{{orderList[index]}}</el-radio>
        </el-col>
        <el-col :span="23">
          <HdEditor
            v-model="questionData.options[index]"
          />
          <!-- <el-input  placeholder="请输入内容" v-model="questionData.options[index]"></el-input> -->
        </el-col>
        <el-col :span="1" class="center">
          <el-button type="text" icon="el-icon-delete"  @click="delOptions(index)"></el-button>
        </el-col>
      </el-row>
      <el-row class="fs12 color-theam1">
        <el-col
          :span="3"
          :offset="1"
          v-if="questionData.options.length < orderList.length">
          <el-button type="text" @click="addOptions">增加选项</el-button>
        </el-col>
        <!-- <el-col :span="3" class="mouseHand" :offset="2">
          删除选项
        </el-col> -->
      </el-row>
      <el-row class="fs12">
        解析:
      </el-row>
      <el-row class="pd-tb10">
        <el-input
          type="textarea"
          v-model="questionData.analysis"
          :autosize="{ minRows: 2, maxRows: 4}"
          placeholder="">
        </el-input>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'HdSmartSingle',
  data(){
    return {
      orderList:["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
      questionData:{
        content:"",//题干
        analysis:"",//解析
        options:["","","",""],//选项
        answer: "1",//答案
      }
    }
  },
  props:['isClear','default'],
  created(){
    let _self = this;

    _self.isDefault();
  },
  methods:{
    isDefault(){
      let _self = this;
      if(_self.default != undefined){
        _self.questionData.content  = _self.default.content;
        _self.questionData.answer   = Number(_self.default.answer);
        _self.questionData.analysis = _self.default.analysis;
        _self.questionData.options  = _self.default.options;
      }
    },
    delOptions(index){
      /*删除选项*/
      let _self = this;

      if (index > -1 && _self.questionData.options.length > 1) {
        _self.questionData.options.splice(index, 1);
      }else{
        _self.$message({
          message: '多选答案最少包含一项',
          type   : 'warning'
        })
      }
    },
    addOptions(){
      /*增加选项*/
      let _self = this;
      if(_self.questionData.options.length >= _self.orderList.length){
        _self.$message({
          message: '选项超出限制了哦',
          type   : 'warning'
        })
        return
      }
      _self.questionData.options.push("");
    },
    multData(){

    }
  },
  watch:{
    questionData:{
      handler(val){
        let _self = this;
        _self.$emit('questionData',val)
      },
      deep: true,
    },
    isClear:{
      handler(val){
        let _self = this;
        if(_self.isClear){
          new Promise((resolve,reject)=>{
            _self.questionData = {
              content:"",//题干
              analysis:"",//解析
              options:["","","",""],//选项
              answer: "",//答案
            };
            resolve()
          }).then(()=>{
            _self.$emit("clearState",true)
          })
        }
      },
      deep: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.center{
  display: flex;
  align-items: center;
}
.option{
      font-size: 14px;
    margin: 15px 5px;
}
.bg-eee{
      background: #eee;
}
.border-radio10 {
    border-radius: 10px;
}
</style>
